<script>
    import Loader from '../Utilities/Loader.svelte';

    import {getObjects} from '../lib/data.js';

    let table_loader = getObjects("table", {fields: ["id", "name"]})
</script>

{#await table_loader}
    <Loader />
{:then tables}
<div class="title">Findings Tables</div>
<table class="table is-fullwidth">
    <thead>
        <tr>
            <th>Table</th>
            <th style="width: 350px">Actiuns</th>
        </tr>
    </thead>
    <tbody>
        {#each tables as table}
            <tr>
                <td>{table.name}</td>
                <td>
                    <div class="buttons">
                        <a href="#/findings/templates/table/{table.id}" class="button">Edit</a>
                    </div>
                </td>
            </tr>
        {/each}
    </tbody>
</table>
{/await}